import styled from 'styled-components';
import { UserOutlined as UserOutlinedIcon } from '@ant-design/icons';
import MenuAntd from 'antd/es/menu';
import Link from 'next/link';

export const UserOutlined = styled(UserOutlinedIcon)`
  color: ${({ theme }) => theme.palette.primaryBrand};
  font-size: 15px;
`;

export const LogoutButtonWrapper = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const Menu = styled(MenuAntd)`
  border-right: none;
`;

export const MenuItem = styled(MenuAntd.Item)`
  text-align: center;
`;

export const PopoverContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 215px;
`;

export const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 0 10px;
  font-size: 14px;
  transition: color 0.3s ease;
  color: ${({ theme }) => theme.palette.lightBlack};

  &:hover {
    color: ${({ theme }) => theme.palette.lightBlack};
  }
`;

export const TotalMileAmountWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

export const UserFullNameLabel = styled.span`
  color: ${({ theme }) => theme.palette.primaryBrand};
  font-weight: bold;
  padding: 0px 26px;
  margin-top: 4px;
  margin-bottom: 8px;
`;
